// ** Modules
import { useQuery } from '@apollo/client/react';
import { gql, type TypedDocumentNode } from '@apollo/client';

// ** Types
import type { Query, PaginationArg } from '@/types/graphql';

export type EhrenamtDocumentsConnectionVariables = {
	filters?: Record<string, any>;
	pagination?: Partial<PaginationArg>;
	sort?: string[] | string | null;
};

export const getEhrenamtDocumentsConnection: TypedDocumentNode<
	Pick<Query, 'ehrenamtDocuments_connection'>,
	EhrenamtDocumentsConnectionVariables
> = gql`
    query EhrenamtDocumentsConnection($filters: EhrenamtDocumentFiltersInput, $pagination: PaginationArg, $sort: [String]) {
        ehrenamtDocuments_connection(filters: $filters, pagination: $pagination, sort: $sort) {
            nodes {
                documentId
                __typename
                accessRestriction
                authenticated
                date
                ehrenamtActive
                ehrenamtCategory
                ehrenamtDocumentDescription
                files {
                    documentId
                    url
                    mime
                    name
                }
            }
            pageInfo {
                page
                pageCount
                pageSize
                total
                __typename
            }
        }
    }
`;

export const useGetEhrenamtDocumentsConnection = (groups: string[]) => {
	const cleanGroups = (groups ?? []).map((g) => g.replace(/^"|"$/g, '').trim()).filter(Boolean);

	const jsonGroups = cleanGroups.map((g) => JSON.stringify(g));
	const { data, ...rest } = useQuery(getEhrenamtDocumentsConnection, {
		ssr: false,
		fetchPolicy: 'no-cache',
		variables: {
			filters: {
				accessRestriction: {
					in: jsonGroups
				}
			},
			pagination: {
				page: 1,
				pageSize: 1000
			},
			sort: ['date:desc']
		},
		skip: cleanGroups.length === 0
	});

	const connection = data?.ehrenamtDocuments_connection;

	return {
		...rest,
		data,
		hasDocuments: (connection?.pageInfo?.total ?? 0) > 0,
		nodes: connection?.nodes || [],
		total: connection?.pageInfo?.total || 0,
		pageInfo: connection?.pageInfo
	};
};
